
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTimeago } from '~shared/utils/hooks';
import { getScheduleStart, translationFunction } from './utils';
import { useTranslation, Trans } from 'react-i18next';

import {
    BB_BETCARD_FOOTER_CSS_CLASS_FEED,
    BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT,
    BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME,
    BB_BETCARD_FOOTER_CSS_CLASS_TOP,
    I18N_BETCARD_STARTS_IN,
} from '../../constants';


const MostRecentFooter = ({isTopBet, commonDataEvents}) => {
    const [t] = useTranslation();
    const timeRef = useTimeago({ translation: translationFunction(t) });
    const scheduleStart = getScheduleStart(commonDataEvents);

    return (
        <div className={classnames([BB_BETCARD_FOOTER_ICON_CSS_CLASS_BLOCK_NAME, {
            [BB_BETCARD_FOOTER_CSS_CLASS_TOP]: isTopBet,
            [BB_BETCARD_FOOTER_CSS_CLASS_FEED]: !isTopBet,
        }])}>
             <Trans t={t} i18nKey={I18N_BETCARD_STARTS_IN}>
                <span className={BB_BETCARD_FOOTER_CSS_CLASS_HIGHLIGHT} ref={timeRef} dateTime={scheduleStart} />
            </Trans>
        </div>
    );
};

MostRecentFooter.propTypes = {
    commonDataEvents: PropTypes.instanceOf(Object).isRequired,
    isTopBet: PropTypes.bool,
};

MostRecentFooter.defaultProps = {
    isTopBet: false,
};

export default MostRecentFooter;
